import moment from "moment";
import * as React from "react";

interface Props {
  eventStartDate: string;
  eventEndDate: string;
  registrationStartDate: string;
  registrationEndDate: string;
  danceRegistrationStartDate: string;
  danceRegistrationEndDate: string;
  videoUrl: string;
  registrationUrl: string;
  isRegistrationOpen: boolean;
}

export type TimelineCardType =
  | "upcoming"
  | "before_event_in_registration_period"
  | "before_event_not_in_registration_period"
  | "event_day_without_video_url"
  | "event_day_with_video_url"
  | "past_event";

const useTimelineCardType = (data: Props): TimelineCardType => {
  const currentDay = moment();

  const generateCardType = React.useCallback((): TimelineCardType => {
    const {
      eventStartDate,
      eventEndDate,
      registrationStartDate,
      registrationEndDate,
      videoUrl,
      danceRegistrationStartDate,
      danceRegistrationEndDate,
    } = data;

    const withinFutsalRegistrationDate = moment(currentDay)?.isBetween(
      registrationStartDate,
      registrationEndDate,
      "day",
      "[]",
    );

    const withinDanceRegistrationDate = moment(currentDay)?.isBetween(
      danceRegistrationStartDate,
      danceRegistrationEndDate,
      "day",
      "[]",
    );

    const withinRegistrationDate = !!withinFutsalRegistrationDate || !!withinDanceRegistrationDate;

    const withinEventDate = moment(currentDay)?.isBetween(
      eventStartDate,
      eventEndDate,
      "day",
      "[]",
    );
    const isBeforeRegistrationPeriod = moment(currentDay)?.isBefore(registrationStartDate, "day");
    const isAfterRegistrationPeriod = moment(currentDay)?.isAfter(registrationEndDate, "day");
    const isBeforeEventEndDate = moment(currentDay)?.isBefore(eventEndDate, "day");

    /**
     * Upcoming Condition:
     * 1. Before registration period`
     * 2. Not within registration date range
     * 3. Not within event date range
     * 4. No video url
     */
    if (isBeforeRegistrationPeriod && !withinRegistrationDate && !withinEventDate) {
      return "upcoming";
    }

    /**
     * Before Event In Registration Period
     * 1. Within registration date range
     * 2. No video URL
     */
    if (withinRegistrationDate) {
      return "before_event_in_registration_period";
    }

    /**
     * Before Event Not In Registration Period
     * 1. After registration period
     * 2. Not within registration date range
     * 3. Not within event date range
     * 4. No Video Url
     * 5. Before event end date
     */
    if (
      isAfterRegistrationPeriod &&
      !withinRegistrationDate &&
      !withinEventDate &&
      isBeforeEventEndDate
    ) {
      return "before_event_not_in_registration_period";
    }

    /**
     * Event Day
     * 1. Within event date range
     * 2. Not within registration date
     * 3. No video url
     * 4.
     */
    if (withinEventDate && !withinRegistrationDate && !videoUrl) {
      return "event_day_without_video_url";
    }

    /**
     * Event Day Final
     * 1. Within event date range
     * 2. Not within registration date
     * 3. Have video url
     */
    if (withinEventDate && !withinRegistrationDate && videoUrl) {
      return "event_day_with_video_url";
    }

    /**
     * pas Event
     * 1. Past event
     * 2. Not within registration date
     * 3. Not within event date range
     */
    return "past_event";
  }, [data]);

  return generateCardType();
};

export default useTimelineCardType;
